import React from 'react';
import AppErrorBoundary from '@crm/components/AppErrorBoundary';
import { CccAuthProvider } from '../contexts/CccAuthContext';
import CccSessionBootstrap from './CccSessionBootstrap';

/**
 * CCC shell — auth only. AppProvider wraps authenticated routes (not /login).
 */
export const CrmShellProviders: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <AppErrorBoundary scope="Auth">
    <CccAuthProvider>
      <CccSessionBootstrap>{children}</CccSessionBootstrap>
    </CccAuthProvider>
  </AppErrorBoundary>
);
